export default __webpack_public_path__ + "static/media/AdminDefaultImg.791bbf4f.png";